import CreateProviderOnboarding from './create-provider-onboarding';

export default CreateProviderOnboarding;
